import React, { useEffect } from 'react'

import './Header2.css'
import AOS from "aos";
import "aos/dist/aos.css"; 
import { NavLink } from 'react-router-dom'

export default function Header() {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once
    });
  }, []);

  
  
  return (
    <>
   
   <div className='image1 d-md-flex justify-content-center'>
   <NavLink to={'/'}><img src='/funfillia_logo_white.png' width='200px' height='' title='Funfillia' alt='Funfillia'/></NavLink> 
   </div>

    </> 
  )
}
